// src/pages/contact.js
import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { businessSchemaDE, businessSchemaEN } from "../schema";
import Contact from "../components/contact/contact";

// Import page-level translations
import contactEnTranslations from "../translations/contact_en.json";
import contactDeTranslations from "../translations/contact_de.json";

const ContactPage = () => {
  const { t, i18n } = useTranslation();

  // Add translations for this page
  i18n.addResourceBundle(
    "en",
    "contactPage",
    contactEnTranslations,
    true,
    true
  );
  i18n.addResourceBundle(
    "de",
    "contactPage",
    contactDeTranslations,
    true,
    true
  );

  const currentSchema =
    i18n.language === "en" ? businessSchemaEN : businessSchemaDE;

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(currentSchema)}
        </script>
        <title>{t("contactPage:page_title")}</title>
        <meta name="description" content={t("contactPage:meta_description")} />
        <meta name="keywords" content={t("contactPage:meta_keywords")} />
        <meta property="og:title" content={t("contactPage:page_title")} />
        <meta
          property="og:description"
          content={t("contactPage:meta_description")}
        />
      </Helmet>
      <Contact />
    </>
  );
};

export default ContactPage;
